export const GOOGLEMAP_KEY = 'AIzaSyDv9cInUZDS_O0fyvFwpKWZA55QSYzJRFM';
